
import {
  get,
  post,
  loginApi,
  getDynamicynamic,
  getFileUseBlobByPost,
} from "./http";
// 基础平台公共接口
export const login = (reqdata) => loginApi("/login", reqdata);

export const loginDuplicateCheck = (reqdata) => post("/loginDuplicateCheck", reqdata);

export const OPACloginDuplicateCheck = (reqdata) => post("/OPACloginDuplicateCheck", reqdata);

export const loginOPAC = (reqdata) => post("/loginOPAC", reqdata);

export const logout = (reqdata) => get("/loginout", reqdata);

export const sendSms = (reqdata) => get("/sendSms", reqdata);

export const setPassword = (reqdata) => post("/changePassword", reqdata);

export const updateoldPassword = (reqdata) => post("/updateoldPassword", reqdata);

export const menu = (reqdata) => get("/menu/getRouts", reqdata);

export const menuTreeList = (reqdata) => get("/menu/menuTreeList", reqdata);

export const idByChildrenId = (reqdata) => get("/menu/idByChildrenId", reqdata);

export const getPerssion = (reqdata) => get("/menu/getPerssion", reqdata);

export const getLibraryTree = (reqdata) => post("/library/getLibTree", reqdata);

export  const getlocalCode = (reqdata) => get("/library/getlocalCode", reqdata);

export const permission = (reqdata) => post("/menu/save", reqdata);

export const configuration = (reqdata) => get("/config/list", reqdata);

export const getList = (reqdata) => post("/helpCatalog/getList", reqdata);

export const loginByPhone = (reqdata) => loginApi("/loginByPhone", reqdata);

export const isExistPhone = (reqdata) => get("/isExistPhone",reqdata);


